export default "__VITE_ASSET__PLa1A1HC__"